import { Outlet } from 'react-router-dom';

/** Account section (§7.1). Its sub-nav lives in the app shell, not duplicated here. */
export function AccountLayout() {
  return (
    <div className="account">
      <Outlet />
    </div>
  );
}
